import * as api from "../../../api"; 


  

export const createNewPageCMRest = (post) => async (dispatch)=>{
    try {
        const {data } = await api.createNewPageCMRest(post);
       
        return data;
        
        
     } catch (error) {
       
    }
}


export const createNewSectionCMRest = (post) => async (dispatch)=>{
    try {
        const {data } = await api.createNewSectionCMRest(post);
       
        return data;
        
        
     } catch (error) {
       
    }
}

export const createNewSectionTemplateCMRest = (post) => async (dispatch)=>{
    try {
        const {data } = await api.createNewSectionTemplateCMRest(post);
       
        return data;
        
        
     } catch (error) {
       
    }
}


